import React, { useState } from "react";
import { Button, ModalProps } from "antd";
import CommonModal from "../../../../components/Modals/CommonModal";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store/app";
import { deletePortedOutFromUsReport } from "../../../../store/portedOutFromUsReportsSlice";

interface DeleteModalProps extends ModalProps {
  title?: string;
  close: any;
  open: boolean;
  deleteValues: any;
  getList: any;
}

const DeleteReport: React.FC<DeleteModalProps> = ({
  title,
  close,
  open,
  deleteValues,
  getList,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const [saving, setSaving] = useState<boolean>(false);

  const deleteProduct = () => {
    setSaving(true);

    const payload = {
      id: deleteValues,
    };
    dispatch(deletePortedOutFromUsReport(payload))
      .then((res: any) => {
        getList();
        close();
      })
      .catch((error: any) => {
        console.log("error", error);
        close();
      })
      .finally(() => setSaving(false));
  };

  return deleteValues ? (
    <CommonModal
      className="deleteModal"
      title={`Delete ${title}`}
      open={open}
      onCancel={close}
      footer={[
        <Button key="2" htmlType="button" className="EditBtn" onClick={close}>
          Cancel
        </Button>,
        <Button
          key="1"
          htmlType="button"
          type="primary"
          className="cancelBtn"
          loading={saving}
          onClick={deleteProduct}
        >
          Delete
        </Button>,
      ]}
    >
      <div className="deleteNote">
        Are you sure want to delete this ported out from us report ?
      </div>
    </CommonModal>
  ) : (
    <></>
  );
};
export default DeleteReport;
